/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { t } from 'i18next';
import { Container, LabelContainer, Label, Input, Error, Optional, USError } from './css';
import {isUSZipError} from '../../../../utils/validator';

const TextInput = ({
  input,
  label,
  errorMessage,
  optional,
  placeholder,
  disabled,
  maxLength,
  meta: { touched, error } = {},
  tooltip,
  icon,
  name,
  page,
  isAuthenticated,
}) => {
  const [usError, setUsError] = useState(false);
  const hasIcon = icon && icon.src && icon.alt;
  const fieldName = input.name;

  const isBillingField = fieldName === 'billTo' || fieldName === 'billingAccountNumber';

  useEffect(() => {
    if(isAuthenticated === false) {
      if ((page && page === 'Create Quote') && (fieldName === 'shipperPostalZipCode' || fieldName === 'consigneePostalZipCode')) {
        const isError = isUSZipError(input && input.value);
        setUsError(isError);

        if (input.value === '') {
          setUsError(false);
        }
      }
    }
  }, [input.value]);

  const handleChange = (event) => {
    const onlyDigits = event.target.value.replace(/\D/g, '');
    input.onChange(onlyDigits);
  };

  return (
    <Container isIconCursorBePointer={!!(icon && icon.onClick)}>
      {label &&
        <LabelContainer>
          <Label>{label} {optional && <Optional>({t('Optional')})</Optional>}</Label>
          {tooltip && tooltip}
        </LabelContainer>
      }
      {isBillingField
        ? <Input
          {...input}
          type='text'
          autoComplete='off'
          placeholder={placeholder}
          maxLength={maxLength}
          disabled={disabled}
          hasIcon={hasIcon}
          onChange={handleChange}
        />
        : (page && page === 'Create Quote') && (fieldName === 'shipperPostalZipCode' || fieldName === 'consigneePostalZipCode')
          ? <Input
          {...input}
          type='text'
          autoComplete='off'
          placeholder={placeholder}
          maxLength={maxLength}
          disabled={disabled}
          hasIcon={hasIcon}
        />
        : <Input
          {...input}
          type='text'
          autoComplete='off'
          placeholder={placeholder}
          maxLength={maxLength}
          disabled={disabled}
          hasIcon={hasIcon}
        />}
      {hasIcon && (
        <img src={icon.src} alt={icon.alt} onClick={icon.onClick} aria-hidden='true' />
      )}
      {
        label === t('PostalZipCode')
        ? (error || errorMessage) && (<Error>{error || errorMessage}</Error>)
        : ((touched && error) || errorMessage) && (<Error>{error || errorMessage}</Error>
        )
      }
      
      {usError && (<USError>{t('NoServiceOutsideCanada')}</USError>)}
    </Container>
  )
};

export default TextInput;
